"use client";

import React from "react";
import { ArrowRight, Mail, MapPin, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const contactDetails = [{
  title: "Διεύθυνση",
  content: "Λεωφόρος Αθηνών 29\nΑχαρνές, 136 71",
  icon: MapPin
}, {
  title: "Τηλέφωνο",
  content: "210 240 6471",
  icon: Phone
}, {
  title: "Email",
  content: "info@milconsult.gr",
  icon: Mail
}];
export default function Contact() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}